module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/main-bg_1e730cdd30ad04280d798ac1901892bc.svg";